/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { IExpLogger } from '../../interface';
import * as optimizely from '@optimizely/optimizely-sdk';

// tslint:disable: no-any

/**
 * Optimizely listener implementation
 */
class OptimizelyConnectorListener implements IExpLogger {
    private userId:string = '';
    private optimizelyClientInstance:optimizely.Client | undefined;
    public initializeClientSide(config?: any, userId?: string): boolean {
        if(!config){
            return false;
        }
        this.userId = userId || '';
        try {
            this.optimizelyClientInstance = optimizely.createInstance(
                { datafile: config }
            );
        } catch(e) {
            throw e;
        }
        return true;


    }

    // Call the track event to pass eventKey, userId and the custom payload info
    public logEvent(eventName: string, payload: any, attributes?: any): void {
        
        // We dont have any user attributes to pass 
        attributes = null;

        // Optimizely expects revenue to come in cents so we convert the revenue dollar amount in the payload to cents
        if (payload.revenue) {
            payload.revenue = parseFloat(payload.revenue) * 100
        }
        // @ts-ignore Ignore argument of type null for attributes
        this.optimizelyClientInstance && this.optimizelyClientInstance.track(eventName, this.userId, attributes, payload);
    }
}

const connectorListener = new OptimizelyConnectorListener();
export default connectorListener;
